import { Bounce, toast, type ToastOptions } from 'react-toastify';

export const _handleTh = (amount: string) => {
	if (!amount) return '';
	const toNumber = parseFloat(amount.replace(/\D/g, ''));
	const toLocale = toNumber.toLocaleString();
	return toLocale;
};

export const _separator = (name: string) => {
	const arr = name
		.split('')
		.map((item, index) => {
			if (index !== 0) {
				if (item === item.toUpperCase()) {
					return ' ' + item;
				} else {
					return item;
				}
			} else return item;
		})
		.toString()
		.replace(/,/g, '');
	return arr.charAt(0).toUpperCase() + arr.slice(1).toLowerCase();
};

const joinS = (arr: string) => arr.toUpperCase();

export const _joiner = (name: string) => {
	const arr = name
		.trim()
		.split('_')
		.map((item, index) => {
			if (index !== 0) {
				if (item === item.toUpperCase()) {
					return ' ' + joinS(item);
				} else {
					return joinS(item);
				}
			} else return joinS(item);
		})
		.toString()
		.replace(/,/g, '');
	return arr;
};

export function _removeHTML(data: string) {
	const regExp = /(&nbsp;|<([^>]+)>)/gi;
	const wSExp = /\s{2,}/gi;
	const res = data.replace(regExp, '');
	return res.replace(wSExp, ' ');
}

export const returnValue = (query: string, value: any) => (value ? query + '' + value : '');

export const checkReturned = (data: string) => (data ? '?' + data : '');

export const getAorAn = (name: string) => {
	if (!name) return '';
	switch (name[0].toLowerCase()) {
		case 'a':
		case 'e':
		case 'i':
		case 'o':
		case 'u':
			return 'an';
		default:
			return 'a';
	}
};

export const capitalizeFirstLetter = (sentence?: string): string => {
	if (!sentence) return '';
	return sentence.charAt(0).toUpperCase() + sentence.slice(1);
};

export const ToastPosition: ToastOptions = {
	position: 'top-right',
	autoClose: 2000,
	hideProgressBar: true,
	closeOnClick: true,
	rtl: false,
	pauseOnFocusLoss: true,
	draggable: true,
	pauseOnHover: true,
	progress: undefined,
	theme: 'colored',
	transition: Bounce,
};

export const showToast = (type: 'success' | 'error', message: string) => {
	switch (type) {
		case 'success':
			toast.success(capitalizeFirstLetter(message), ToastPosition);
			break;
		case 'error':
			toast.error(capitalizeFirstLetter(message), ToastPosition);
			break;
		default:
			throw new Error(`Invalid toast type: ${type as string}`);
	}
};
